import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import parse from "html-react-parser";

import { fetchTermsOfUse } from "../../redux/slice/termsOfUse/termsOfUse";

import "./TermsPublic.scss";
import LineWhiteArrowIcon from "../../assets/images/LineWhiteArrow.svg";
import { useLocalizes } from "../../utils/useLocalizes";

export default function TermsPublic() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { termsData, loading } = useSelector((state) => state.termsOfUse);
  const htmlString = termsData?.[0]?.attributes?.Terms_Of_Use;
  const { 
    loading: localizesLoading, 
    error: localizesError, 
    getLocalizedValue
  } = useLocalizes();
  const tncDate = getLocalizedValue("dlf_tnc_date", "Updated 05 August, 2025");
  useEffect(() => {
    dispatch(fetchTermsOfUse());
    // eslint-disable-next-line
  }, []);

  return (
    <div className="privacyhome">
      <div className="home-bg" style={{ position: "relative", height: "auto" }}>
        <div 
          className="back" 
          onClick={() => navigate(-1)}
          role="button"
        >
          <img src={LineWhiteArrowIcon} alt="back arrow" />
        </div>
        <div className="heading">
          <p className="redtext">{tncDate}</p>
          <h1 className="privacytext">Terms & Conditions</h1>
        </div>
      </div>
        {loading && termsData?.length === 0 ? (
          <div className="spinner_table_height">
            <Spinner color="black" />
          </div>
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: htmlString }}
            className="tNc1"
          />
        )}
    </div>
  );
}
